import React, { useEffect } from 'react';

const RulesChat = () => {
  useEffect(() => {
    window.location.href = 'https://balboney.sandiego.golf';
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <p>Redirecting to <a href="https://balboney.sandiego.golf">balboney.sandiego.golf</a>...</p>
    </div>
  );
};

export default RulesChat;
